<template>
    <div class="ma-4">
        <v-snackbar v-model="msg" top :color="snackbarColor"> {{ text }}
            <v-btn color="pink" text @click="msg = false"> Close</v-btn>
        </v-snackbar>
        <ClientNav/>
        <v-row dense>
            <v-col cols="12" lg="3" xl="2">
                <ClientSide/>
            </v-col>
            <v-col cols="12" lg="9" xl="10">
                <v-card class="pa-2" outlined tile height="100%">
                    <v-data-table
                        :headers="headers"
                        :items="visits"
                        sort-by="DateTime"
                        sort-desc
                        :loading="isLoading"
                        loading-text="Loading Visits"
                        :search="search"
                        height="550"
                    >
                        <template v-slot:top>
                            <v-toolbar flat color="white">
                                <v-toolbar-title>Off Site Visits</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-text-field
                                    v-model="search"
                                    clearable
                                    flat
                                    solo-inverted
                                    hide-details
                                    prepend-inner-icon="search"
                                    label="search"
                                    class="desktop"
                                ></v-text-field>
                                <v-spacer></v-spacer>
                                <v-btn v-if="!isAuditorRole" color="#2b3990" dark class="mb-2" @click="showAdd()">
                                    <v-icon left>add</v-icon>
                                    Add Visit
                                </v-btn>
                                
                                
                            <v-spacer></v-spacer>
                            <v-btn class="primary" @click="printTable()">
                                <v-icon small>
                                    print
                                </v-icon>
                                Print
                            </v-btn>
                            </v-toolbar>
                            <v-text-field
                                v-model="search"
                                clearable
                                flat
                                solo-inverted
                                hide-details
                                prepend-inner-icon="search"
                                label="search"
                                class="mobile ml-5 mr-5 mb-3 mt-3"
                            ></v-text-field>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" @click="viewVisit(item)">
                                mdi-eye
                            </v-icon>
                            <v-icon v-if="!isAuditorRole" small @click="deleteVisit(item)">
                                mdi-delete
                            </v-icon>

                        </template>
                        <template v-slot:no-data>
                            <v-btn color="#2b3990" class="white--text" @click="getVisits()">Reset</v-btn>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
        <Foot class="hideOnPrint"/>
        <report-table
            :reportHeaderText="reportHeaderText"
            :tableHeaders="reportTableHeader"
            :tableData="reportData"
        />
    </div>
</template>

<script>
import axios from 'axios'
import ClientNav from '../../components/ClientNav'
import ClientSide from '../../components/ClientSide'
import Foot from '../../components/Footer'
import ReportTable from '@/components/Report/ReportTable.vue';
// import moment from 'moment'
import {mapActions} from "vuex";

const url = require("../../client_config/config").url;
export default {
    components: {
        ClientNav,
        ClientSide,
        Foot,
        ReportTable
    },
    data: function () {
        return {
            headers: [
                {
                    text: 'Date Client is Leaving',
                    align: 'start',
                    sortable: true,
                    value: 'DateTime',
                },
                // { text: "Service Code Name", value: "Name" },
                {text: "Transporting Client", value: "Transporter"},
                {text: "Expected Return", value: "ExpectedDate"},
                {text: "Actual Return", value: "ActualDate"},
                {text: "Staff Signature", value: "StaffSignature"},
                {text: "Actions", value: "actions", sortable: false},
            ],
            date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            msg: false,
            snackbarColor: "black",
            search: "",
            text: "",
            visits: [],
            codes: [],
            users: [],
            clientID: this.$route.params.clientID,
            userID: localStorage.getItem('userID'),
            staff: localStorage.getItem('Name'),
            tempData: [],
            isLoading: true,
            requiredRules: [
                v => !!v || 'This is required',
            ],
            readonly: true,
            disabled: true,
        }
    },

    computed: {
        reportHeaderText() {
            return 'Client Off-Site Visits';
        },
        reportData() {
            return this.visits
        },
        reportTableHeader() {
            return this.headers.slice(0, this.headers.length-1);
        },
        isAuditorRole() {
            return localStorage.getItem("userRole") === 'Auditor'
        }
    },
    watch: {},

    created() {
        this.getVisits();
        if (localStorage.getItem('userRole') === 'Administration' ||
            localStorage.getItem('userRole') === 'Client Services Manager' ||
            localStorage.getItem('userRole') === 'Program Coordinator' ||
            localStorage.getItem('userRole') === 'Human Resources' ||
            localStorage.getItem('userRole') === 'Compliance Manager') {

            this.readonly = false
            this.disabled = false
        }
        this.getClientInfo(this.clientID)
        this.newClient = this.$store.state.clients.client.Name
    },

    methods: {
        ...mapActions({
            getClientInfo: "clients/getClient",
        }),

        initialize() {
            this.visits = [];
        },

        validate() {
            return this.$refs.form.validate()
        },

        viewVisit(item) {
            this.$router.push({
                path: `/offSiteVisit/${this.clientID}/update/${item._id}`,
                query: {updateOffSite: true}
            });
        },

        showAdd() {
            this.$router.push({
                path: `/offSiteVisit/${this.clientID}/new`,
                query: {createOffSite: true}
            });
        },

        deleteVisit(item) {
            const id = item._id;
            confirm("Are you sure you want to delete this off-site visit record?") &&
            this.visitDelete(id);
        },

        visitDelete(id) {
            axios.delete(`${url}/offSite/${id}`)
                .then((response) => {
                    this.getVisits();
                    if (response.status === 400) {
                        response.json().then(function (data) {
                            return data.msg;
                        });
                    }
                    this.snackbarColor = "black";
                    this.msg = true;
                    this.text = "The off-site visit record has been deleted successfully.";
                });
        },


        getVisits() {
            this.isLoading = true;
            axios.get(`${url}/offSite/client/${this.clientID}`).then(res => {
                this.visits = res.data.visits
            })
            this.isLoading = false;
        },

        printTable() {
            document.getElementById('printTable').style.display = "block";
            window.print()
            document.getElementById('printTable').style.display = "none";
        }

    },
};
</script>
<style>
#printTable{
    display: none;
}
@media only screen and (min-width: 768px) {
    .mobile {
        display: none;
    }
}

@media only screen and (max-width: 600px) {
    .desktop {
        display: none;
    }
}

@media print {
    #printTable {
      display: block;
      border: none;
      width: 1200px;
      padding-right: 300px;
      margin-left: -200px;
    }
  
    .hideOnPrint {
      display: none;
      border: none;
    }
  
    nav.v-navigation-drawer, header.v-toolbar, button.v-btn, div.v-card {
      display: none;
      border: none;
  
    }
  
    @page { margin: 0; }
    body { margin: 1.6cm; }
}
</style>
